import { z } from 'zod'

import {
  createEmptyFloorplanDocument,
  createEmptyFloorplanImageDocument,
  floorplanCalibrationSchema,
  floorplanDocumentObjectSchema,
  floorplanDocumentSchema,
  floorplanImageDocumentSchema,
  floorplanImageSectionSchema,
  floorplanImageTableSchema,
  floorplanRestoreVersionResponseSchema,
  floorplanHistoryEventSchema,
  floorplanHistoryRecordSchema,
  floorplanSurfaceMaterialSchema,
  floorplanVersionListItemSchema,
  floorplanVersionListResponseSchema,
  floorplanVersionResponseSchema,
  floorplanVersionSnapshotSchema,
  floorplanTraceBackgroundSchema,
  roomShellDocumentSchema,
  venueLayoutCreateArgsSchema,
  venueLayoutFloorPlanInputSchema,
  venueLayoutSchema,
  venueLayoutUpdateByIdArgsSchema,
  venueLayoutListSchema,
} from './schemas/venueLayout'

export type VenueLayout = z.infer<typeof venueLayoutSchema>

export type VenueLayoutFloorPlanInput = z.infer<
  typeof venueLayoutFloorPlanInputSchema
>

export type VenueLayoutCreateArgs = z.infer<typeof venueLayoutCreateArgsSchema>

export type VenueLayoutUpdateByIdArgs = z.infer<
  typeof venueLayoutUpdateByIdArgsSchema
>

export type FloorplanDocument = z.infer<typeof floorplanDocumentSchema>
export type FloorplanImageDocument = z.infer<
  typeof floorplanImageDocumentSchema
>
export type FloorplanImageSection = z.infer<typeof floorplanImageSectionSchema>
export type FloorplanImageTable = z.infer<typeof floorplanImageTableSchema>
export type FloorplanSurfaceMaterial = z.infer<
  typeof floorplanSurfaceMaterialSchema
>
export type FloorplanDocumentObject = z.infer<
  typeof floorplanDocumentObjectSchema
>
export type FloorplanRoomShell = z.infer<typeof roomShellDocumentSchema>
export type FloorplanCalibration = z.infer<typeof floorplanCalibrationSchema>
export type FloorplanTraceBackground = z.infer<
  typeof floorplanTraceBackgroundSchema
>
export type FloorplanVersionSnapshot = z.infer<
  typeof floorplanVersionSnapshotSchema
>
export type FloorplanHistoryEvent = z.infer<typeof floorplanHistoryEventSchema>
export type FloorplanHistoryRecord = z.infer<
  typeof floorplanHistoryRecordSchema
>
export type FloorplanVersionListItem = z.infer<
  typeof floorplanVersionListItemSchema
>
export type FloorplanVersionListResponse = z.infer<
  typeof floorplanVersionListResponseSchema
>
export type FloorplanVersionResponse = z.infer<
  typeof floorplanVersionResponseSchema
>
export type FloorplanRestoreVersionResponse = z.infer<
  typeof floorplanRestoreVersionResponseSchema
>

export {
  buildImageDocFromLayoutEntities,
  createEmptyFloorplanDocument,
  createEmptyFloorplanImageDocument,
} from './schemas/venueLayout'
export {
  getDefaultVenueLayoutAvailability,
  getIsLayoutPublic,
  isVenueLayoutPublished,
  isFloorplanImageDocument,
  isFloorplanV3Document,
  layoutHasAnyV3Floorplan,
  layoutIsActiveOnDate,
  layoutHasLiveV2ImagePublished,
  layoutHasLiveV3Published,
  layoutHasV3FloorplanInLegacyStorage,
  layoutMatchesFloorplanSchemaVersions,
  layoutHasV2ImageFloorplan,
  layoutHasV3Floorplan,
  resolveLayoutFloorPlanImageUrl,
  resolveLayoutFloorplanSchemaVersion,
  resolvePublishedImageDocument,
  resolveVenueLayoutFloorplanImageUrl,
  resolveVenueLayoutFloorplanMode,
} from './utils/venueLayoutFloorplan'
export type { VenueLayoutFloorplanMode } from './utils/venueLayoutFloorplan'

export type VenueLayoutListQuery = z.infer<typeof venueLayoutListSchema>
